import styled from 'styled-components'

export default styled.div`
  margin-top: -57px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km0};
  }
`
